<template>
<div class="bus-paper">
  <div id="bus" class="bus-page" :style="'background-image: url(' + dashboardBg + ');zoom: ' + zoom + ';'">
    <div class="dashboard-title">远程C8M醇氢电动商用客车数字孪生系统</div>
    <!--左边信息-->
    <div class="left-info-wrapper">
      <div class="left-item">
        <div class="left-title">里程信息</div>
        <div class="value-box">
          <div class="num">{{ params.full_mileage | formatNumber }}</div>
          <div class="unit">km</div>
        </div>
      </div>
      <div class="left-item">
        <div class="left-title">速度信息</div>
        <div class="value-box">
          <div class="num">{{ params.running_speed }}</div>
          <div class="unit">km/h</div>
        </div>
      </div>
      <div class="left-item">
        <div class="left-title">电量信息</div>
        <div class="line-box">
          <div class="v-line color-electric" v-for="i in 20" :key="i"
               :class="i< (20-getLineVal(params.power_full_amount,params.power_left_amount))?
                    (params.power_left_amount/params.power_full_amount <0.2?'warning':'active'):''">
          </div>
        </div>
        <div class="content">
          <div>
            <div>
              <span class="number">{{ params.power_left_amount | formatNumber }}</span>
              <span class="unit">kwh</span>
            </div>
            <div class="name">Remaining</div>
          </div>
          <div>
            <div>
              <span class="number">{{ params.power_full_amount | formatNumber }}</span>
              <span class="unit">kwh</span>
            </div>
            <div class="name">Fullapacity</div>
          </div>

        </div>
      </div>
    </div>
    <!--汽车主体-->
    <div class="bus-dashboard-container">
      <div class="bus-container">
        <img src="@/assets/bus/bus-img.png" alt="" class="bus-img"/>
        <!--气体流动-->
        <div class="bus-line-wrapper">
          <img src="@/assets/bus/c8m-lines.png" alt="" class="bus-lines"/>
          <img src="@/assets/bus/bus-words.png" alt="" class="bus-words"/>
          <template v-if="params.running_speed >0">
            <div class="gas-y1" :style="'background-image: url(' +gas_y_left+ ');'"></div>
            <div class="gas-y2" :style="'background-image: url(' +gas_y_down+ ');'"></div>
            <div class="gas-y3" :style="'background-image: url(' +gas_y_up+ ');'"></div>
          </template>
          <template v-if="machine_is_running">
            <div class="gas-y4" :style="'background-image: url(' +gas_y_right+ ');'"></div>
            <div class="gas-y5" :style="'background-image: url(' +gas_y_left+ ');'"
                 v-if="params.running_speed > 0"></div>
          </template>
          <template v-if="battery_is_running">
            <div class="gas-o" :class="machine_is_running? '': 'slow'"
                 :style="'background-image: url(' +gas_o_right+ ');'"></div>
            <div class="gas-p1" :class="machine_is_running? '': 'slow'"
                 :style="'background-image: url(' +gas_p_down+ ');'"></div>
            <div class="gas-p2" :class="machine_is_running? '': 'slow'"
                 :style="'background-image: url(' +gas_p_left+ ');'"></div>
            <div class="gas-b1" :class="machine_is_running? '': 'slow'"
                 :style="'background-image: url(' +gas_b_down+ ');'"></div>
            <div class="gas-b2" :class="machine_is_running? '': 'slow'"
                 :style="'background-image: url(' +gas_b_right+ ');'"></div>
          </template>
        </div>
        <!--轮胎-->
        <img src="@/assets/bus/bus-tyre.png" alt="" class="tyre left"
             :class="is_running&&params.running_speed >0?'round': ''"/>
        <img src="@/assets/bus/bus-tyre.png" alt="" class="tyre right"
             :class="is_running &&params.running_speed >0? 'round': ''"/>
        <!--燃料堆栈按钮-->
        <div class="info-btn" @click.stop="handleShowBatteryDialog">查看详情</div>
      </div>
    </div>
    <!--右边信息-->
    <div class="right-info-wrapper">
      <div class="right-item">
        <div class="right-title">余醇信息</div>
        <div class="right-content">
          <div class="methanol">
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;flex-direction: column; justify-content: space-between;flex: 1;">
                <div>
                  <div class="text-right">
                    <!--甲醇容量-->
                    <span class="number">{{ params.methanol_full_amount | formatNumber }}</span>
                    <span class="unit">L</span>
                  </div>
                  <div class="name text-right">FullCapacity</div>
                </div>
                <div class="text-right">
                  <div>
                    <!--甲醇余量-->
                    <span class="number">{{ params.methanol_left_amount | formatNumber }}</span>
                    <span class="unit">L</span>
                  </div>
                  <div class="name text-right">Remaining</div>
                </div>
              </div>
              <div style="width: 22px;margin-left: 12px">
                <div class="h-line color-methanol" v-for="i in 20" :key="i"
                     :class="i > getLineVal(params.methanol_full_amount,params.methanol_left_amount)?
                      (params.methanol_left_amount/params.methanol_full_amount <0.2?'warning':'active')
                      : ''">
                </div>
              </div>
            </div>
            <div class="text-right" style="padding-top: 12px">甲醇</div>
          </div>
          <div class="water">
            <div style="display: flex;justify-content: space-between">
              <div style="width: 22px;margin-right: 12px">
                <div class="h-line color-water" v-for="i in 20" :key="i"
                     :class="i> getLineVal(params.water_full_amount,params.water_left_amount)?
                     (params.water_left_amount/params.water_full_amount < 0.2 ? 'warning': 'active'): ''">
                </div>
              </div>
              <div style="display: flex;flex-direction: column; justify-content: space-between;flex: 1;">
                <div class="text-left">
                  <div>
                    <!--水容量-->
                    <span class="number">{{ params.water_full_amount | formatNumber }}</span>
                    <span class="unit">L</span>
                  </div>
                  <div class="name">FullCapacity</div>
                </div>
                <div class="text-left">
                  <div>
                    <span class="number">{{ params.water_left_amount | formatNumber }}</span>
                    <span class="unit">L</span>
                  </div>
                  <div class="name">Remaining</div>
                </div>
              </div>
            </div>
            <div class="text-left" style="padding-top: 12px">水</div>
          </div>
        </div>
      </div>
      <!--核载/实载-->
      <div class="left-person-wrapper">
        <div class="left-person">
          <span class="name">实载人数</span>
          <span class="number">{{ params.people_left_amount | formatNumber }}</span>
        </div>
        <div class="left-person">
          <span class="name">核载人数</span>
          <span class="number">{{ params.people_full_amount | formatNumber }}</span>
        </div>
      </div>
    </div>
    <!--底部小图标    -->
    <div class="bottom-opr-box">
      <div class="left-opr">
        <img src="@/assets/bus/btn-debug.png" alt="" class="debug" @click="handleBtnOpr('debug')">
        <img src="@/assets/bus/btn-setting.png" alt="" class="debug" @click="handleBtnOpr('setting')">
      </div>
      <img src="@/assets/bus/c8m-loading.png" alt="" class="loading">
      <div class="right-opr">
        <img src="@/assets/bus/btn-home.png" alt="" class="debug" @click="handleBtnOpr('gohome')">
        <img src="@/assets/bus/btn-refresh.png" alt="" class="refresh" @click="handleBtnOpr('refresh')">
      </div>
    </div>
    <!--提示框-->
    <div class="tip-container" v-if="notifyRules.length">
      <div :key="key" class="tip-box" v-for="(item, key) in notifyRules"
           :style="'background-image: url(' + dialogArr[String(item.level)] + ');'">
        <!--关闭-->
        <p class="top-close" @click="removeNotify(key)"></p>
        <div class="img-box">
          <img src="@/assets/dialog-img-1.png" alt="" v-show="item.level == 1"/>
          <img src="@/assets/dialog-img-2.png" alt="" v-show="item.level == 2"/>
          <img src="@/assets/dialog-img-3.png" alt="" v-show="item.level == 3"/>
          <span :class="'tip-color-'+ item.level">{{ notifyName['level' + item.level] }}</span>
        </div>
        <div class="msg">{{ item.message }}</div>
      </div>
    </div>
    <!--各种变量-->
    <div class="params-container" v-if="is_debug">
      <div class="params-box">
        <p>是否启动: {{ is_running ? '是' : '否' }}</p>
        <p> 车辆速度: {{ params.running_speed }}km/h</p>
        <p>核载人数: {{ params.people_full_amount }}</p>
        <p> 实载人数: {{ params.people_left_amount }}</p>
        <hr>
        <h4><strong>主要参数</strong></h4>
        <p>总里程: {{ params.full_mileage }}km</p>
        <p>总耗电量: {{ params.full_power_consumption }}kwh</p>
        <p>总启动时长: {{ params.full_run_seconds | toLocalTime }}</p>
        <p>本次里程: {{ params.mileage }}km</p>
        <p>本次里程耗电量: {{ params.power_consumption }}kwh</p>
        <p>本次启动时长: {{ params.run_seconds | toLocalTime }}</p>
        <p>甲醇容量: {{ params.methanol_full_amount }}L</p>
        <p>甲醇余量: {{ params.methanol_left_amount }}L</p>
        <p>水容量: {{ params.water_full_amount }}L</p>
        <p>水余量: {{ params.water_left_amount }}L</p>
        <p>电池容量: {{ params.power_full_amount }}kwh</p>
        <p>电池余量: {{ params.power_left_amount }}kwh</p>
        <hr>
        <h4><strong>甲醇重整器参数</strong></h4>
        <p>运行总时长: {{ params.machine_full_run_seconds | toLocalTime }}</p>
        <p>本次启动时长: {{ params.machine_run_seconds | toLocalTime }}</p>
        <p>当前环境PH值: {{ params.machine_ph }}</p>
        <p>当前温度: {{ params.machine_temperature }}°C</p>
        <p>当前气压: {{ params.machine_pressure }}Mp</p>
        <p>加醇总量: {{ params.machine_methanol_amount }}L</p>
        <p>耗醇总量: {{ params.machine_methanol_full_consume_amount }}L</p>
        <p>本次启动耗醇量: {{ params.machine_methanol_consume_amount }}L</p>
        <p>当前醇耗: {{ params.machine_methanol_consume_ratio }}</p>
        <p>加水总量: {{ params.machine_water_amount }}L</p>
        <p>耗水总量: {{ params.machine_water_full_consume_amount }}L</p>
        <p>本次启动耗水量: {{ params.machine_water_consume_amount }}L</p>
        <p>当前水耗: {{ params.machine_water_consume_ratio }}</p>
        <p>当前水醇比: {{ params.machine_water_methanol_ratio }}</p>
        <p>本次启动发电量: {{ params.machine_create_power }}kwh</p>
        <p>蒸气成分氯含量: {{ params.machine_cl_ratio }}</p>
        <p>蒸气成份硫含量: {{ params.machine_s_ratio }}</p>
        <hr>
        <h4><strong>产物气体含量</strong></h4>
        <p>CH3OH: {{ params.machine_ch3oh_ratio }}</p>
        <p>CO: {{ params.machine_co_ratio }}</p>
        <p>H20: {{ params.machine_h2o_ratio }}</p>
        <p>CO2: {{ params.machine_co2_ratio }}</p>
        <p>H2: {{ params.machine_h2_ratio }}</p>
        <p>积碳检测: {{ params.machine_carbon_deposition ? '有' : '无' }}</p>
        <hr>
        <h4><strong>电池堆栈参数</strong></h4>
        <p>甲醇水泵温度: {{ params.water_pump_temperature }}°C</p>
        <p>氧化传感器温度: {{ params.oxidize_temperature }}°C</p>
        <p>主风机转速: {{ params.main_fan_rota_speed }}转</p>
        <p>T10重整器上: {{ params.t10 }}°C</p>
        <p>T11重整器下: {{ params.t11 }}°C</p>
        <p>T12一级气化: {{ params.t12 }}°C</p>
        <p>T13二级气化: {{ params.t13 }}°C</p>
        <p>T15下堆温: {{ params.t15 }}°C</p>
        <p>T19进堆空气: {{ params.t19 }}°C</p>
        <p>T20进堆氢气: {{ params.t20 }}°C</p>
        <p>T21出堆空气: {{ params.t21 }}°C</p>
        <p>T22出堆氢气: {{ params.t22 }}°C</p>
        <p>T23高温重制: {{ params.t23 }}°C</p>
        <p>T3燃烧器下: {{ params.t3 }}°C</p>
        <p>T34电加热重整进口: {{ params.t34 }}°C</p>
        <p>T35电加热重整: {{ params.t35 }}°C</p>
        <p>T4燃烧器上: {{ params.t4 }}°C</p>
        <p>T5重整出氢: {{ params.t5 }}°C</p>
        <p>T7废气出口: {{ params.t7 }}°C</p>
        <p>T9重整烟气: {{ params.t9 }}°C</p>
        <p>电堆停止次数: {{ params.battery_stop_count }}次</p>
        <hr>
        <p v-for="(item,key) in debug_data" :key="key">
          {{ key }}: {{ item }}
        </p>
        <hr>
      </div>
    </div>
    <!--燃料堆弹框-->
    <transition name="fade">
      <div class="battery-dialog" v-if="showBattery">
        <div class='battery-modal'>
          <img src="@/assets/bus/bus-battery.png" alt="">
          <div class="close" @click.stop="handleBatteryDialogClose"></div>
          <img src="@/assets/bus/battery-fan.png" alt="" class="b-fan" :class="params.methanol_pump_speed > 0 ?'round': ''">
          <img src="@/assets/bus/battery-pump.png" alt="" class="b-pump" :class="params.methanol_pump_speed > 0 ?'round': ''">
          <img src="@/assets/bus/battery-fire.png" alt="" class="b-fire" :class="params.methanol_pump_speed > 0 ?'running': ''">
          <img src="@/assets/bus/battery-light.png" alt="" class="b-light" :class="params.methanol_pump_speed > 0 ?'running': ''">
          <!--电池线条-->
          <template v-if="params.methanol_pump_speed > 0">
            <div class="battery-line line1" :style="'background-image: url(' +battery_arrow_left+ ');'"></div>
            <div class="battery-line line2" :style="'background-image: url(' +battery_arrow_left+ ');'"></div>
            <div class="battery-line line3" :style="'background-image: url(' +battery_arrow_right+ ');'"></div>
            <div class="battery-line line4" :style="'background-image: url(' +battery_arrow_right+ ');'"></div>
            <div class="battery-line line5" :style="'background-image: url(' +battery_arrow_right+ ');'"></div>
            <div class="battery-line line6" :style="'background-image: url(' +battery_arrow_right+ ');'"></div>
            <div class="battery-line line7" :style="'background-image: url(' +battery_arrow_right+ ');'"></div>
            <div class="battery-line line8" :style="'background-image: url(' +battery_arrow_left+ ');'"></div>
            <div class="battery-line line9" :style="'background-image: url(' +battery_arrow_up+ ');'"></div>
            <div class="battery-line line10" :style="'background-image: url(' +battery_arrow_up+ ');'"></div>
            <div class="battery-line line11" :style="'background-image: url(' +battery_arrow_down+ ');'"></div>
            <div class="battery-line line12" :style="'background-image: url(' +battery_arrow_up+ ');'"></div>
            <div class="battery-line line13" :style="'background-image: url(' +battery_arrow_down+ ');'"></div>
            <div class="battery-line line14" :style="'background-image: url(' +battery_arrow_left+ ');'"></div>
            <div class="battery-line line15" :style="'background-image: url(' +battery_arrow_up+ ');'"></div>
          </template>
          <div class="fan-top">阴极空气进口</div>
          <div class="fan-bottom">风机</div>
          <div class="words-item left1">低压用电</div>
          <div class="words-item left2">低压模块</div>
          <div class="words-item left3">车载动力电池</div>
          <div class="words-item left4">升压模块</div>
          <div class="words-item left5">稳压器</div>
          <div class="box-item right-fan">
            <div class="name">风机转速</div>
            <div class="value" :class="getBatteryClass('main_fan_rota_speed', params.main_fan_rota_speed)">
              {{ params.main_fan_rota_speed | formatNumber }}rpm
            </div>
          </div>
          <div class="box-item right-t19">
            <div class="name">T19进堆空气</div>
            <div class="value" :class="getBatteryClass('t19', params.t19)">{{ params.t19 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t21">
            <div class="name">T21出堆空气</div>
            <div class="value" :class="getBatteryClass('t21', params.t21)">{{ params.t21 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t22">
            <div class="name">T22出堆氢气</div>
            <div class="value" :class="getBatteryClass('t22', params.t22)">{{ params.t22 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t20">
            <div class="name">T20进堆氢气</div>
            <div class="value" :class="getBatteryClass('t20', params.t20)">{{ params.t20 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t4">
            <div class="name">T4燃烧器上</div>
            <div class="value" :class="getBatteryClass('t4', params.t4)">{{ params.t4 }}℃</div>
          </div>
          <div class="box-item right-t3">
            <div class="name">T3燃烧器下</div>
            <div class="value" :class="getBatteryClass('t3', params.t3)">{{ params.t3 }}℃</div>
          </div>
          <div class="box-item right-oxy">
            <div class="name">氧化传感器参数</div>
            <div class="value" :class="getBatteryClass('oxidize_temperature', params.oxidize_temperature)">
              {{ params.oxidize_temperature | formatNumber }}%
            </div>
          </div>
          <div class="box-item right-t15">
            <div class="name">T15下堆温</div>
            <div class="value" :class="getBatteryClass('t15', params.t15)">{{ params.t15 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t9">
            <div class="name">T9重整烟气</div>
            <div class="value" :class="getBatteryClass('t9', params.t9)">{{ params.t9 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t23">
            <div class="name">T23高温重整</div>
            <div class="value" :class="getBatteryClass('t23', params.t23)">{{ params.t23 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t10">
            <div class="name">T10重整器上</div>
            <div class="value" :class="getBatteryClass('t10', params.t10)">{{ params.t10 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t11">
            <div class="name">T11重整器下</div>
            <div class="value" :class="getBatteryClass('t11', params.t11)">{{ params.t11 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t12">
            <div class="name">T12一级汽化</div>
            <div class="value" :class="getBatteryClass('t22', params.t22)">{{ params.t22 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t13">
            <div class="name">T13二级汽化</div>
            <div class="value" :class="getBatteryClass('t13', params.t13)">{{ params.t13 | formatNumber }}℃</div>
          </div>
          <div class="box-item right-t7">
            <div class="name">T7废气出口</div>
            <div class="value" :class="getBatteryClass('t7', params.t7)">{{ params.t7 }}℃</div>
          </div>
          <div class="box-item right-bump-speed">
            <div class="name">甲醇泵转速</div>
            <div class="value" :class="getBatteryClass('methanol_pump_speed', params.methanol_pump_speed)">
              {{ params.methanol_pump_speed }}rpm
            </div>
          </div>
          <div class="box-item right-pump">
            <div class="value" :class="getBatteryClass('water_pump_temperature', params.water_pump_temperature)">
              {{ params.water_pump_temperature | formatNumber }}℃
            </div>
            <div class="name">甲醇水泵</div>
          </div>
          <div class="box-item left-DC-1">
            <div class="name">DC</div>
            <div class="value" :class="getBatteryClass('battery_low_voltage', params.battery_low_voltage)">
              {{ params.battery_low_voltage | formatNumber }}V
            </div>
          </div>
          <div class="box-item left-DC-2">
            <div class="name">DC</div>
            <div class="value" :class="getBatteryClass('battery_high_voltage', params.battery_high_voltage)">
              {{ params.battery_high_voltage | formatNumber }}V
            </div>
          </div>
          <div class="box-item left-P">
            <div class="name">电功率</div>
            <div class="value" :class="getBatteryClass('battery_low_voltage', params.battery_low_voltage)">
              {{ (50 * Number(params.battery_low_voltage))  |  formatNumber }}W
            </div>
          </div>
          <div class="right-name name1">电堆</div>
          <div class="right-name name2">燃烧器</div>
          <div class="right-name name3">氧传感器</div>
          <div class="right-name name4">空气换热器</div>
          <div class="right-name name5">高温重整器</div>
          <div class="right-name name6">低温重整器</div>
          <div class="right-name name7">汽化器</div>
          <div class="right-name name8">电加热启动装置</div>
          <div class="right-name name9">燃烧用电磁阀</div>
          <div class="right-name name10">发电用电磁阀</div>
          <div class="right-name name11">尾气出口</div>
          <div class="right-name name12">甲醇水</div>
          <div class="b-title t1">电力输出系统</div>
          <div class="b-title t2">甲醇SOFC发电系统</div>
        </div>
      </div>
    </transition>
  </div>
</div>
</template>

<script>
import {alarmRules, paramsLast, paramsUpdate} from "@/api/car"
import {computed} from "vue"

export default {
  name: "C8mDashboard",
  data() {
    return {
      type: 'c8m',
      zoom: 1,
      dashboardBg: require('@/assets/bus/c8mBg.png'),
      // 底部背景图
      bg_start: require('@/assets/bus/speed_start.png'),
      bg_start_ing: require('@/assets/bus/speed-start-s.png'),
      bg_speed_up: require('@/assets/bus/speed-up.png'),
      bg_speed_up_ing: require('@/assets/bus/speed-up-s.png'),
      bg_speed_down: require('@/assets/bus/speed-down.png'),
      bg_speed_down_ing: require('@/assets/bus/speed-down-s.png'),
      bg_stop: require('@/assets/bus/speed-stop.png'),
      bg_stop_ing: require('@/assets/bus/speed-stop-s.png'),
      //
      gas_y_left: require('@/assets/bus/gas-y-left.png'),
      gas_y_down: require('@/assets/bus/gas-y-down.png'),
      gas_y_up: require('@/assets/bus/gas-y-up.png'),
      gas_y_right: require('@/assets/bus/gas-y-right.png'),
      gas_p_down: require('@/assets/bus/gas-p-down.png'),
      gas_p_left: require('@/assets/bus/gas-p-left.png'),
      gas_o_right: require('@/assets/bus/gas-o-right.png'),
      gas_b_down: require('@/assets/bus/gas-b-down.png'),
      gas_b_right: require('@/assets/bus/gas-b-right.png'),
      center_btn_bg: require('@/assets/bus/bus-center-btn.png'),
      //电池
      battery_arrow_left: require('@/assets/bus/b-arrow-left.png'),
      battery_arrow_right: require('@/assets/bus/b-arrow-right.png'),
      battery_arrow_up: require('@/assets/bus/b-arrow-up.png'),
      battery_arrow_down: require('@/assets/bus/b-arrow-down.png'),
      //
      is_debug: false,
      //
      is_running: false, // 是否运行
      running_sh: null, // 运行sh
      machine_is_running: false, // 甲醇重整器 是否运行
      battery_is_running: true, // 电池运行

      speed_add_sh: null,
      speed_sub_sh: null,
      keyStatus: null,
      //
      maxMethanolAmount: 50, //甲醇最大容量
      maxWaterAmount: 65, //水最大容量
      maxPowerAmount: 50, //水最大容量

      params: {
        running_speed: 0, // 速度 km/h
        last_running_speed: 0, // 速度 km/h 上一次
        last_stop_timestamp: 0, // 上一次停车（运行中但速度为0）时间戳
        full_mileage: 0, // 总里程 km
        mileage: 0, // 本次里程 km  2024-07-23 添加
        full_power_consumption: 0, //总耗电量 kwh
        full_run_seconds: 0, // 总启动时长 s
        power_consumption: 0, //本次里程耗电量 kwh
        run_seconds: 0, // 本次启动时长 s
        methanol_full_amount: 50, // 甲醇容量 L
        methanol_left_amount: 50, // 甲醇余量 L
        water_full_amount: 65, // 水容量 L
        water_left_amount: 65, // 水余量 L
        power_full_amount: 40, // 电池总容量 kwh
        power_left_amount: 30, // 剩余电量 kwh
        people_full_amount: 53, // 核载人数 人
        people_left_amount: 10, // 实载人数 人
        // 甲醇重整器参数
        machine_full_run_seconds: 0, // 运行总时长 s
        machine_run_seconds: 0, // 本次启动时长 s
        machine_ph: 0, // 当前环境PH值
        machine_temperature: 0, // 当前温度
        machine_pressure: 0, // 当前气压
        // 醇
        machine_methanol_amount: 100, // 加醇总量 L
        machine_methanol_full_consume_amount: 0, // 耗醇总量 L
        machine_methanol_consume_amount: 0, // 本次启动耗醇量 L
        machine_methanol_consume_ratio: 0, // 当前醇耗
        // 水
        machine_water_amount: 130, // 加水总量 L
        machine_water_full_consume_amount: 0, // 耗水总量 L
        machine_water_consume_amount: 0, // 本次启动耗水量 L
        machine_water_consume_ratio: 0, // 当前水耗

        machine_water_methanol_ratio: 1.3, // 当前水醇比

        machine_create_power: 0, // 本次启动发电量 kwh
        machine_cl_ratio: 0, // 蒸气成分氯含量
        machine_s_ratio: 0, // 蒸气成份硫含量
        machine_ch3oh_ratio: 0, // 产物气体含量 CH3OH
        machine_co_ratio: 0, // 产物气体含量 CO
        machine_h2o_ratio: 0, // 产物气体含量 H20
        machine_co2_ratio: 0, // 产物气体含量 CO2
        machine_h2_ratio: 0, // 产物气体含量 H2
        machine_carbon_deposition: 0, // 积碳检测
        //
        water_pump_temperature: 50, // 甲醇水泵温度
        oxidize_temperature: 7.9, // 氧化传感器温度
        main_fan_rota_speed: 1800, // 主风机转速
        methanol_pump_speed: 600, // 甲醇泵转速
        t10: 291.4, // T10重整器上
        t11: 298.9, // T11重整器下
        t12: 364.7, // T12一级气化
        t13: 302.1, // T13二级气化
        t15: 643.9, // T15下堆温
        t19: 302.1, // T19进堆空气
        t20: 683.6, // T20进堆氢气
        t21: 559.5, // T21出堆空气
        t22: 694.4, // T22出堆氢气
        t23: 637.5, // T23高温重制
        t3: 821.2, // T3燃烧器下
        t34: 463.2, // T34电加热重整进口
        t35: 605.0, // T35电加热重整
        t4: 753.2, // T4燃烧器上
        t5: 605.0, // T5重整出氢
        t7: 226.4, // T7废气出口
        t9: 319.2, // T9重整烟气
        battery_low_voltage: 43.5, // 电堆低压
        battery_high_voltage: 735.5, // 电堆高压
        battery_stop_count: 0, // 电堆停止次数
      },
      batteryRules: {
        water_pump_temperature: [40, 60], // 甲醇水泵温度
        oxidize_temperature: [0, 10], // 氧化传感器温度
        main_fan_rota_speed: [100, 3000], // 主风机转速
        methanol_pump_speed: [0, 100], //甲醇泵转速
        t10: [200, 500], // T10重整器上
        t11: [200, 500], // T11重整器下
        t12: [200, 500], // T12一级气化
        t13: [200, 500], // T13二级气化
        t15: [600, 800], // T15下堆温
        t19: [600, 800], // T19进堆空气
        t20: [600, 800], // T20进堆氢气
        t21: [600, 800], // T21出堆空气
        t22: [600, 800], // T22出堆氢气
        t23: [600, 800], // T23高温重制
        t3: [700, 1000], // T3燃烧器下
        t34: [300, 600], // T34电加热重整进口
        t35: [600, 800], // T35电加热重整
        t4: [700, 1000], // T4燃烧器上
        t5: [600, 800], // T5重整出氢
        t7: [200, 500], // T7废气出口
        t9: [200, 500], // T9重整烟气
        battery_low_voltage: [12, 24], // 电堆低压
        battery_high_voltage: [600, 800], // 电堆高压
      },
      rules: [],
      //
      dialogArr: {
        '1': require('@/assets/dialog-bg-1.png'),
        '2': require('@/assets/dialog-bg-2.png'),
        '3': require('@/assets/dialog-bg-3.png'),
      },
      notifyName: {
        level1: '严重',
        level2: '提示',
        level3: '普通',
      },
      notifyRules: [
        // {
        //   id: 1,
        //   level: '1', // 1严重 2提示 3 普通
        //   message: "严重严重严重严重严重严重",
        // },
      ],
      debug_content: '甲醇-0,水-0,充电+0,时速0,里程+0,耗电-0',
      debug_data: {
        '甲醇': '-0',
        '耗水': '-0',
        '充电': '+0',
        '时速': '0',
        '里程': '+0',
        '耗电': '-0',
      },
      //
      hoverOn: null,
      methanolInput: 0,
      waterInput: 0,
      peopleOutInput: 0,
      peopleInInput: 0,
      last_submit_time: 0,
      //
      showBattery: false,
      batteryTimer: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    maxChangePeople() {
      return this.params.people_full_amount - this.params.people_left_amount
    },
    maxChangeMethanol() {
      return this.params.methanol_full_amount - this.params.methanol_left_amount
    },
    maxChangeWater() {
      return this.params.water_full_amount - this.params.water_left_amount
    },
    getBatteryClass() {
      return function (key, value) {
        console.log(key)
        if (value >= this.batteryRules[key][0] && value <= this.batteryRules[key][1]) {
          return 'normal'
        }
        return 'warning'
      }
    },
  },
  filters: {
    toLocalTime(seconds) {
      let left_seconds = seconds
      let hour = 0, minute = 0
      if (left_seconds >= 3600) {
        hour = Math.floor(left_seconds / 3600)
        left_seconds = left_seconds % 3600
      }
      if (left_seconds >= 60) {
        minute = Math.floor(left_seconds / 60)
        left_seconds = left_seconds % 60
      }
      return hour + '小时' + minute + '分钟' + left_seconds + '秒'
    },
    formatNumber(num) {
      if (num > 0) {
        if (/[.]/.test(num)) {
          return parseFloat(num).toFixed(1)
        }
        return num
      }
      return num
    }
  },
  created() {
    if (!this.user.has_bus_permission) {
      this.$router.replace('/index')
    }
  },
  mounted() {
    let that = this
    that.flushConfig()
    that.calcZoom()
    window.addEventListener('resize', () => {
      that.calcZoom()
    })
    //加速减速-添加快捷键
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    this.running_sh && clearInterval(this.running_sh)
    this.speed_add_sh && clearInterval(this.speed_add_sh)
    this.speed_sub_sh && clearInterval(this.speed_sub_sh)
    this.batteryTimer && clearInterval(this.batteryTimer)

    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('keyup', this.handleKeyUp)
  },
  methods: {
    calcZoom() {
      let that = this
      let w_radio = window.innerWidth / 1920
      let h_radio = window.innerHeight / 1080
      that.zoom = Math.min(w_radio, h_radio)
    },
    getLineVal(full, left) {
      if (left < 0.1) return 20
      let unit = (full / 20)
      let n = left / unit
      return Math.floor(20 - n)
    },
    // 底部小按钮
    handleBtnOpr(key) {
      if (['setting', 'gohome', 'refresh'].includes(key) && this.is_running) {
        this.$message.error('请停止运行')
        return
      }
      if (key === 'debug') {
        console.log('用户点击debug')
        this.is_debug = !this.is_debug
      }
      if (key === 'setting') {
        console.log('用户点击设置')
        this.$router.push('/c8m/setting')
      }
      if (key === 'gohome') {
        console.log('用户点击返回首页')
        this.$router.push('/index')
      }
      if (key === 'refresh') {
        console.log('用户点击刷新')
        if (this.is_running) return
        this.flushConfig()
      }
    },
    handleMethanolMinus() {
      if (this.methanolInput < 1) return
      this.methanolInput -= 1
    },
    handleMethanolPlus() {
      if (this.params.methanol_left_amount >= this.params.methanol_full_amount ||
        Number(this.methanolInput) >= this.maxChangeMethanol) {
        return
      }
      this.methanolInput += 1
    },
    handleMethanolSubmit() {
      let time = (new Date()).getTime()
      let last_submit_time = this.last_submit_time
      this.last_submit_time = time
      if (time - last_submit_time < 500) {
        this.$message.error('请勿频繁点击')
        return
      }
      let methanol_left_amount = parseFloat((this.params.methanol_left_amount + this.methanolInput).toFixed(6))
      if (methanol_left_amount > this.params.methanol_full_amount) {
        methanol_left_amount = this.params.methanol_full_amount
      }
      if (methanol_left_amount < 0) {
        methanol_left_amount = 0
      }
      this.params.methanol_left_amount = methanol_left_amount
      this.updateParams({methanol_left_amount: this.params.methanol_left_amount})
    },
    handleWaterMinus() {
      if (this.waterInput < 1) return
      this.waterInput -= 1
    },
    handleWaterPlus() {
      if (this.params.water_left_amount >= this.params.water_full_amount ||
        Number(this.waterInput) >= this.maxChangeWater) {
        return
      }
      this.waterInput += 1
    },
    handleWaterSubmit() {
      let time = (new Date()).getTime()
      let last_submit_time = this.last_submit_time
      this.last_submit_time = time
      if (time - last_submit_time < 500) {
        this.$message.error('请勿频繁点击')
        return
      }
      let water_left_amount = parseFloat((this.params.water_left_amount + this.waterInput).toFixed(6))
      if (water_left_amount > this.params.water_full_amount) {
        water_left_amount = this.params.water_full_amount
      }
      if (water_left_amount < 0) {
        water_left_amount = 0
      }
      this.params.water_left_amount = water_left_amount
      this.updateParams({water_left_amount: this.params.water_left_amount})
    },
    handlePeopleInMinus() {
      if (this.peopleInInput < 1) return
      this.peopleInInput -= 1
    },
    handlePeopleInPlus() {
      if (this.params.people_left_amount >= this.params.people_full_amount ||
        Number(this.peopleInInput) >= this.maxChangePeople) {
        return
      }
      this.peopleInInput += 1
    },
    handlePeopleOutMinus() {
      if (this.peopleOutInput < 1) return
      this.peopleOutInput -= 1
    },
    handlePeopleOutPlus() {
      if (Number(this.peopleOutInput) >= this.params.people_left_amount) return
      this.peopleOutInput += 1
    },
    handlePeopleSubmit(is_in) {
      let time = (new Date()).getTime()
      let last_submit_time = this.last_submit_time
      this.last_submit_time = time
      if (time - last_submit_time < 500) {
        this.$message.error('请勿频繁点击')
        return
      }
      let people_left_amount
      if (is_in) {
        people_left_amount = this.params.people_left_amount + this.peopleInInput
      } else {
        people_left_amount = this.params.people_left_amount - this.peopleOutInput
      }
      if (people_left_amount > this.params.people_full_amount) {
        people_left_amount = this.params.people_full_amount
      }
      if (people_left_amount < 0) {
        people_left_amount = 0
      }
      this.params.people_left_amount = people_left_amount
      this.updateParams({people_left_amount: this.params.people_left_amount})
    },
    inputChange(e, key) {
      let num = Number(e)
      if (key === 'peopleInInput' && num >= this.maxChangePeople) {
        num = this.maxChangePeople
      }
      if (key === 'peopleOutInput' && num >= this.params.people_left_amount) {
        num = this.params.people_left_amount
      }
      if (key === 'waterInput' && num >= this.maxChangeWater) {
        num = this.maxChangeWater
      }
      if (key === 'methanolInput' && num >= this.maxChangeMethanol) {
        num = this.maxChangeMethanol
      }
      this[key] = num > 0 ? num : 0
      this.$forceUpdate()
    },
    //
    flushConfig() {
      this.getLastParams()
      this.getRules()
    },
    getLastParams() {
      let that = this
      paramsLast({type: that.type}).then(res => {
        that.setParams(res)
      })
    },
    handleShowBatteryDialog() {
      let that = this
      that.showBattery = true
      that.getBatteryParams()
      if (that.battery_is_running) {
        that.batteryTimer = setInterval(() => {
          that.getBatteryParams()
        }, 5000)
      }
    },
    handleBatteryDialogClose() {
      this.showBattery = false
      this.batteryTimer && clearInterval(this.batteryTimer)
    },
    // 获取电池参数
    getBatteryParams() {
      let that = this
      let keys = Object.keys(that.batteryRules)
      paramsLast({
        type: that.type,
        keys: keys
      }).then(res => {
        for (let key of keys) {
          that.params[key] = res[key] || 0
        }
      })
    },
    getRules() {
      let that = this
      alarmRules({type: that.type}).then(res => {
        that.rules = res
      })
    },
    updateParams(params = null) {
      let that = this
      params = params || that.params
      paramsUpdate({...params, type: that.type}).then(() => {

      })
    },
    setParams(params) {
      this.params.last_running_speed = params.last_running_speed || 60
      this.params.full_mileage = params.full_mileage || 0
      this.params.full_power_consumption = params.full_power_consumption || 0
      this.params.full_run_seconds = params.full_run_seconds || 0
      this.params.power_consumption = params.power_consumption || 0
      this.params.run_seconds = params.run_seconds || 0
      this.params.methanol_full_amount = params.methanol_full_amount || 0
      this.params.methanol_left_amount = params.methanol_left_amount || 0
      this.params.water_full_amount = params.water_full_amount || 0
      this.params.water_left_amount = params.water_left_amount || 0
      this.params.power_full_amount = params.power_full_amount || 0
      this.params.power_left_amount = params.power_left_amount || 0
      this.params.people_full_amount = params.people_full_amount || 0
      this.params.people_left_amount = params.people_left_amount || 0
      this.params.machine_full_run_seconds = params.machine_full_run_seconds || 0
      this.params.machine_run_seconds = params.machine_run_seconds || 0
      this.params.machine_ph = params.machine_ph || 0
      this.params.machine_temperature = params.machine_temperature || 0
      this.params.machine_pressure = params.machine_pressure || 0
      this.params.machine_methanol_amount = params.machine_methanol_amount || 0
      this.params.machine_methanol_full_consume_amount = params.machine_methanol_full_consume_amount || 0
      this.params.machine_methanol_consume_amount = params.machine_methanol_consume_amount || 0
      // this.params.machine_methanol_consume_ratio = params.machine_methanol_consume_ratio || 0
      this.params.machine_water_amount = params.machine_water_amount || 0
      this.params.machine_water_full_consume_amount = params.machine_water_full_consume_amount || 0
      this.params.machine_water_consume_amount = params.machine_water_consume_amount || 0
      // this.params.machine_water_consume_ratio = params.machine_water_consume_ratio || 0
      this.params.machine_water_methanol_ratio = params.machine_water_methanol_ratio || 0
      this.params.machine_create_power = params.machine_create_power || 0
      this.params.machine_cl_ratio = params.machine_cl_ratio || 0
      this.params.machine_s_ratio = params.machine_s_ratio || 0
      this.params.machine_ch3oh_ratio = params.machine_ch3oh_ratio || 0
      this.params.machine_co_ratio = params.machine_co_ratio || 0
      this.params.machine_h2o_ratio = params.machine_h2o_ratio || 0
      this.params.machine_co2_ratio = params.machine_co2_ratio || 0
      this.params.machine_h2_ratio = params.machine_h2_ratio || 0
      this.params.machine_carbon_deposition = params.machine_carbon_deposition ? 1 : 0
      //
      this.params.water_pump_temperature = params.water_pump_temperature || 0
      this.params.oxidize_temperature = params.oxidize_temperature || 0
      this.params.main_fan_rota_speed = params.main_fan_rota_speed || 0
      this.params.methanol_pump_speed = params.methanol_pump_speed || 0
      this.params.t10 = params.t10 || 0
      this.params.t11 = params.t11 || 0
      this.params.t12 = params.t12 || 0
      this.params.t13 = params.t13 || 0
      this.params.t15 = params.t15 || 0
      this.params.t19 = params.t19 || 0
      this.params.t20 = params.t20 || 0
      this.params.t21 = params.t21 || 0
      this.params.t22 = params.t22 || 0
      this.params.t23 = params.t23 || 0
      this.params.t3 = params.t3 || 0
      this.params.t34 = params.t34 || 0
      this.params.t35 = params.t35 || 0
      this.params.t4 = params.t4 || 0
      this.params.t5 = params.t5 || 0
      this.params.t7 = params.t7 || 0
      this.params.battery_low_voltage = params.battery_low_voltage || 0
      this.params.battery_high_voltage = params.battery_high_voltage || 0
      this.params.battery_stop_count = params.battery_stop_count || 0
      console.log('参数：' + JSON.stringify(this.params))
    },
    // 启动车辆
    run() {
      if (this.is_running) return
      if (this.running_sh) {
        clearInterval(this.running_sh)
      }
      if (!this.battery_is_running) {
        this.notifyMessage('batteryIsNotRunning', 1, `电堆未运行`)
        return;
      }
      // 2024-07-23 添加
      if (this.params.methanol_left_amount > this.maxMethanolAmount) {
        this.notifyMessage('maxMethanolAmount', 1, `甲醇余量不能超过${this.maxMethanolAmount}L`)
        return;
      }
      if (this.params.water_left_amount > this.maxWaterAmount) {
        this.notifyMessage('maxWaterAmount', 1, `水余量不能超过${this.maxWaterAmount}L`)
        return;
      }
      if (this.params.power_left_amount > this.params.power_full_amount) {
        this.notifyMessage('power_full_amount', 1, `电余量不能超过40kwh`)
        return;
      }

      this.params.mileage = 0
      this.params.power_consumption = 0
      this.params.run_seconds = 0
      this.params.machine_run_seconds = 0
      this.params.machine_methanol_consume_amount = 0
      this.params.machine_water_consume_amount = 0
      this.params.machine_create_power = 0
      this.params.running_speed = this.params.last_running_speed > 0 ? this.params.last_running_speed : 60 // 默认60km/h
      this.is_running = true
      this.machine_is_running = true
      this.startRunning()
    },
    pause() {
      if (!this.is_running) return
      if (this.running_sh) {
        clearInterval(this.running_sh)
      }
      this.params.last_running_speed = this.params.running_speed
      this.params.running_speed = 0
      this.is_running = false
      this.machine_is_running = false
      this.params.last_stop_timestamp = 0
      this.updateParams()
    },
    startRunning() {
      let that = this
      that.running_sh = setInterval(() => {
        let try_start_machine = false
        // 1
        let sub_methanol = 0.000695
        let add_power = 0.00138
        let sub_water = parseFloat((sub_methanol * that.params.machine_water_methanol_ratio).toFixed(6))
        let machine_can_running = that.params.methanol_left_amount >= sub_methanol && that.params.water_left_amount >= sub_water
        if (!that.machine_is_running && machine_can_running) {
          that.machine_is_running = true
          try_start_machine = true
        }
        that.params.machine_methanol_consume_ratio = computed(() => {
          return that.machine_is_running ? (sub_methanol * 3600).toFixed(2) : 0
        })
        that.params.machine_water_consume_ratio = computed(() => {
          return that.machine_is_running ? (sub_water * 3600).toFixed(2) : 0
        })
        if (that.machine_is_running && !machine_can_running) {
          // 水|醇 不足
          that.machine_is_running = false
          sub_methanol = 0
          add_power = 0
          sub_water = 0
          that.notifyMessage('water-or-methanol-run-over', 2, '水/甲醇不足，停止发电')
        }
        if (that.machine_is_running) {
          that.params.methanol_left_amount = parseFloat((that.params.methanol_left_amount - sub_methanol).toFixed(4))
          that.params.water_left_amount = parseFloat((that.params.water_left_amount - sub_water).toFixed(4))
          let now_power_left_amount = parseFloat((that.params.power_left_amount + add_power).toFixed(4))
          if (now_power_left_amount >= that.params.power_full_amount) {
            // 充满电
            now_power_left_amount = that.params.power_full_amount
            that.machine_is_running = false
            that.notifyMessage('machine-power-full', 2, '电已充满，停止发电')

          }
          if (that.params.last_stop_timestamp > 0 && that.params.running_speed === 0 && Math.floor((new Date()).getTime() / 1000) - that.params.last_stop_timestamp > 600) {
            that.machine_is_running = false
            that.notifyMessage('machine-power-long', 2, '停车发电时间过长，停止发电')
          }
          that.params.power_left_amount = now_power_left_amount
          // 醇
          that.params.machine_methanol_full_consume_amount = parseFloat((that.params.machine_methanol_full_consume_amount + sub_methanol).toFixed(4))
          that.params.machine_methanol_consume_amount = parseFloat((that.params.machine_methanol_consume_amount + sub_methanol).toFixed(4))
          // 水
          that.params.machine_water_full_consume_amount = parseFloat((that.params.machine_water_full_consume_amount + sub_water).toFixed(4))
          that.params.machine_water_consume_amount = parseFloat((that.params.machine_water_consume_amount + sub_water).toFixed(4))

          that.params.machine_create_power = parseFloat((that.params.machine_create_power + add_power).toFixed(4))
        }
        // 2
        let running_speed = that.params.running_speed
        let running_mileage = parseFloat((running_speed / 3600).toFixed(4))
        // 0.2表示平均耗电量修改20kwh/100公里（之前0.15）
        let power_consumption = parseFloat(((Math.abs(running_speed - 60) * 0.0006 + 0.2) * running_mileage).toFixed(4))
        let people_power_consumption = that.params.people_left_amount * 0.0001
        if (that.params.running_speed < 1) {
          people_power_consumption = 0
        }
        power_consumption = parseFloat((power_consumption + people_power_consumption).toFixed(4))
        that.debug_content = `甲醇-${sub_methanol},水-${sub_water},充电+${add_power},时速${running_speed},里程+${running_mileage},耗电-${power_consumption}`
        that.debug_data = {
          '甲醇': '-' + sub_methanol,
          '耗水': '-' + sub_water,
          '充电': '+' + add_power,
          '时速': '' + running_speed,
          '里程': '+' + running_mileage,
          '耗电': '-' + power_consumption,
        }
        if (power_consumption > that.params.power_left_amount) {
          // 电量不足
          that.params.running_speed = 0
          that.notifyMessage('machine-power-off', 2, '电量不足，停止运行')
          return
        }
        if (that.params.running_speed < 1 && !that.machine_is_running) {
          that.pause()
          return
        }

        that.params.mileage = parseFloat((that.params.mileage + running_mileage).toFixed(4))
        that.params.full_mileage = parseFloat((that.params.full_mileage + running_mileage).toFixed(4))
        that.params.full_power_consumption = parseFloat((that.params.full_power_consumption + power_consumption).toFixed(4))
        that.params.power_consumption = parseFloat((that.params.power_consumption + power_consumption).toFixed(4))
        that.params.power_left_amount = parseFloat((that.params.power_left_amount - power_consumption).toFixed(4))
        that.params.full_run_seconds += 1
        that.params.run_seconds += 1
        if (that.machine_is_running) {
          that.params.machine_full_run_seconds += 1
          that.params.machine_run_seconds += 1
        }
        if (try_start_machine && that.machine_is_running) {
          that.notifyMessage('machine-power-lower', 2, '电量不足，启用发电')
        }
        that.checkRules()
      }, 100)
    },
    checkRules() {
      let that = this
      for (let key in that.params) {
        window[key] = that.params[key]
      }
      window.now_timestamp = Math.floor((new Date()).getTime() / 1000)
      for (let i in that.rules) {
        let id = that.rules[i].id
        let formula = that.rules[i].formula
        let level = that.rules[i].level
        let message = that.rules[i].message
        let result = false
        try {
          result = eval(formula)
          // console.log(formula, result)
        } catch (e) {
          console.log('eval error', e)
          result = false
        }
        if (result) {
          that.notifyMessage(id, level, message)
        }
      }
    },
    notifyMessage(id, level, message) {
      console.log('---弹框通知----', id, level, message)
      let that = this
      let index = that.notifyRules.findIndex(item => {
        return item.id === id
      })
      if (index >= 0) return
      that.notifyRules.push({
        id: id,
        level: level,
        message: message,
      })
    },
    removeNotify(index) {
      this.notifyRules.splice(index, 1)
    },
    // 按键下
    handleKeyDown(e) {
      if (!this.is_running) return
      if (e.code === "ArrowUp" && !e.repeat) {
        this.keyStatus = "ArrowUp"
        this.speedAddStart()
      }
      if (e.code === "ArrowDown" && !e.repeat) {
        this.keyStatus = this.params.running_speed > 0 ? "ArrowDown" : null
        this.speedSubStart()
      }
    },
    handleKeyUp(e) {
      this.keyStatus = null
      if (e.code === "ArrowUp") {
        this.speedAddEnd()
      }
      if (e.code === "ArrowDown") {
        this.speedSubEnd()
      }
    },
    speedAddStart() {
      if (!this.is_running) return
      if (this.params.methanol_left_amount < 1) return
      this.speedAddEnd()
      this.speed_add_sh = setInterval(() => {
        if (this.is_running) {
          this.speedAdd()
        } else {
          this.speedAddEnd()
        }
      }, 150)
    },
    speedAddEnd() {
      this.speed_add_sh && clearInterval(this.speed_add_sh)
      this.speed_add_sh = null
    },
    speedSubStart() {
      if (!this.is_running) return
      this.speedSubEnd()
      this.speed_sub_sh = setInterval(() => {
        if (this.is_running) {
          this.speedSub()
        } else {
          this.speedSubEnd()
        }
      }, 150)
    },
    speedSubEnd() {
      this.speed_sub_sh && clearInterval(this.speed_sub_sh)
      this.speed_sub_sh = null
      // 按钮恢复颜色
      if (this.params.running_speed < 1) {
        this.keyStatus = null
      }
    },
    speedAdd() {
      if (!this.is_running) return
      this.params.running_speed += 1
    },
    speedSub() {
      if (!this.is_running) return
      if (this.params.running_speed > 0) {
        this.params.running_speed -= 1
        if (this.params.running_speed < 1) {
          this.params.last_stop_timestamp = Math.floor((new Date()).getTime() / 1000)
        }
      } else {
        this.keyStatus = null
      }
    },
    batteryChangeRunning() {
      if (this.battery_is_running) {
        this.battery_is_running = false
        this.params.battery_stop_count += 1
        this.pause()
      } else {
        this.battery_is_running = true
      }
    },
  }
}
</script>
<style scoped lang="scss">
.bus-paper {
  width: 100vw;
  height: 100vh;
  background: #04080E;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bus-page {
  width: 1920px;
  height: 1080px;
  background: #04080E;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  img {
    -webkit-user-drag: none;
  }

  /*横线*/
  .line-box {
    display: flex;
  }

  .h-line {
    width: 22px;
    height: 3px;
    margin-top: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  .v-line {
    width: 3px;
    height: 22px;
    margin-left: 8px;

    &:first-child {
      margin-left: 0;
    }
  }

  .color-water {
    background: #838486;

    &.active {
      background: #00EAFF;
    }

    &.warning {
      background: red;
    }
  }

  .color-methanol {
    background: #838486;

    &.active {
      background: #81FBB8;
    }

    &.warning {
      background: red;
    }
  }

  .color-electric {
    background: #838486;

    &.active {
      background: #F5E74F;
    }

    &.warning {
      background: red;
      position: relative;
    }
  }

  /*中间大标题*/
  .dashboard-title {
    position: absolute;
    top: 22px;
    left: 0;
    right: 0;
    height: 48px;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 48px;
    letter-spacing: 2px;
    text-shadow: 0px 4px 1px rgba(19,80,143,0.66), 0px 0px 18px rgba(130,165,255,0.57), 0px 0px 2px rgba(255,255,255,0.8);
    text-align: center;
    font-style: normal;
    text-transform: none;
    font-family: 'YouSheBiaoTiHei';
  }

  /*左边信息栏*/
  .left-info-wrapper {
    width: 300px;
    position: absolute;
    top: 140px;
    left: 40px;
    padding: 20px;
    box-sizing: border-box;

    .left-item {
      margin-top: 60px;

      &:first-child {
        margin-top: 0;
      }

      .left-title {
        height: 28px;
        line-height: 28px;
        padding-left: 27px;
        font-weight: bold;
        font-size: 20px;
        color: #F6F9FE;
        font-style: italic;
        text-shadow: 0px 0px 7px rgba(75, 180, 229, 0.25), 0px 2px 8px rgba(5, 28, 55, 0.42);
      }

      .value-box {
        padding-top: 42px;
        margin-left: 122px;

        .num {
          line-height: 48px;
          font-weight: 400;
          font-size: 40px;
          color: #FFFFFF;
          text-align: left;
          font-family: 'YouSheBiaoTiHei';
        }

        .unit {
          line-height: 28px;
          font-size: 20px;
          color: #FFFFFF;
          font-family: 'YouSheBiaoTiHei';
        }
      }

      .line-box {
        margin-top: 42px;
        padding: 0 20px;
        display: flex;
      }

      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        padding: 0 20px;
        color: #fff;

        .name {
          font-weight: 500;
          font-size: 10px;
          color: #FFFFFF;
          line-height: 16px;
        }

        .number {
          font-size: 28px;
          line-height: 33px;
          font-weight: 500;
        }

        .unit {
          font-size: 16px;
          line-height: 16px;
          padding-left: 5px;
        }

      }
    }
  }

  /*右边信息栏*/
  .right-info-wrapper {
    position: absolute;
    top: 140px;
    right: 40px;
    width: 300px;
    z-index: 100;
    box-sizing: border-box;

    .right-item {
      width: 300px;
      padding: 20px;
      box-sizing: border-box;

      &:last-child {
        margin-top: 10px;
        padding-right: 0;
      }

      .right-title {
        padding-left: 27px;
        font-weight: bold;
        font-size: 20px;
        color: #F6F9FE;
        line-height: 28px;
        font-style: italic;
        text-shadow: 0px 0px 7px rgba(75, 180, 229, 0.25), 0px 2px 8px rgba(5, 28, 55, 0.42);
      }

      .right-content {
        display: flex;
        padding-top: 42px;
        color: #fff;

        & > div {
          flex: 1 !important;
        }

        .number {
          font-size: 28px;
        }

        .unit {
          font-size: 16px;
          padding-left: 4px;
        }

        .name {
          font-weight: 500;
          font-size: 10px;
          line-height: 16px;
        }

        .methanol {
          padding-right: 12px;
        }

        .water {
          padding-left: 12px;
        }
      }

      .opr-box {
        position: relative;
        width: 100%;
        height: 40px;
        color: #ffffff;
        overflow: hidden;
        margin-top: 20px;

        &:first-child {
          margin-top: 0;
        }

        .opr-bg {
          position: absolute;
          right: 0;
          top: 0;
          height: 40px;
        }

        .opr-item {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          z-index: 20;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          padding: 4px 0;
          box-sizing: border-box;

          .m-p {
            display: inline-block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #091F33;
            border: 1px solid #1FC6FF;
            box-sizing: border-box;
            color: #fff;
            font-size: 16px;
            cursor: pointer;

            &.disabled {
              border: 1px solid rgba(31, 198, 255, 0.4);
              color: #838486;
            }
          }

          .opr-input {
            display: inline-block;
            width: 64px;
            height: 32px;
            background: #091F33;
            border: 1px solid #1FC6FF;
            box-sizing: border-box;
            overflow: hidden;
            margin: 0 4px;

            :deep(.el-input__inner) {
              height: 32px;
              line-height: 32px;
              width: 64px;
              border: unset;
              color: #ffffff;
              border-radius: unset;
              background: transparent;
              text-align: center;
              font-weight: 500;
              font-size: 16px;
            }
          }

          .name {
            display: inline-block;
            margin-left: 35px;
            min-width: 72px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-weight: 500;
            font-size: 18px;
            text-shadow: 0 0 16px rgba(60, 152, 255, 0.27);
            font-style: normal;
            text-transform: none;
            cursor: pointer;
            box-sizing: border-box;
          }
        }
      }
    }

    /*核载/实载*/
    .left-person-wrapper {
      margin-top: 37px;
      padding: 10px 10px 10px 88px;

      .left-person {
        display: flex;
        line-height: 40px;
        align-items: center;

        &:last-child {
          margin-top: 36px;
        }

        .name {
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
        }

        .number {
          padding-left: 20px;
          font-weight: 400;
          font-size: 24px;
          color: #F5E74F;
          font-family: 'YouSheBiaoTiHei';
        }

      }
    }
  }

  /*底部操作*/
  .bottom-opr-wrapper {
    position: absolute;
    bottom: 50px;
    left: 376px;
    width: 1168px;
    height: 65px;
    z-index: 100;

    .opr-btn {
      width: 262px;
      height: 65px;
      margin-left: 40px;
      background-size: cover;
      display: inline-block;
      font-weight: 500;
      font-size: 28px;
      color: #C0E1FB;
      line-height: 33px;
      cursor: pointer;
      padding: 11px 20px 16px 90px;

      &:first-child {
        margin-left: 0;
      }

      &.active {
        color: #F9E3BA;
      }
    }
  }

  .bottom-opr-box {
    position: absolute;
    left: 760px;
    bottom: 46px;
    width: 400px;
    height: 120px;
    padding: 0 50px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;

    .left-opr, .right-opr {
      width: 120px;
      display: flex;
      align-items: center;
      column-gap: 20px;

      img {
        display: inline-block;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }

    .left-opr {
      justify-content: flex-start;
    }

    .right-opr {
      justify-content: flex-end;
    }

    .loading {
      width: 60px;
      height: 60px;
      animation: loading-rotate 3s linear infinite;
    }

    @keyframes loading-rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  /*中间图片*/
  .bus-dashboard-container {
    position: relative;
    width: 1200px;
    height: 719px;
    margin-left: 360px;
    margin-top: 178px;
    box-sizing: border-box;

    .bus-container {
      position: relative;
      box-sizing: border-box;
      width: 1200px;
      height: 618px;

      .bus-img {
        position: absolute;
        right: 0;
        top: 102px;
        width: 1200px;
        height: 362px;
        z-index: 10;
      }

      /*轮胎*/
      .tyre {
        position: absolute;
        width: 114px;
        height: 114px;
        z-index: 12;
        transition: all 2s;


        &.left {
          left: 226px;
          top: 370px;
        }

        &.right {
          right: 250px;
          top: 370px;
        }

        &.round {
          animation: round .7s infinite linear;
        }
      }

      /*流动*/
      .bus-line-wrapper {
        position: absolute;
        left: 23px;
        top: 0;
        width: 1161px;
        height: 719px;
        z-index: 20;

        .bus-lines {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 32;
          width: 100%;
          height: 100%;
        }

        .bus-words {
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
          z-index: 100;
        }

        .gas-y1 {
          width: 608px;
          height: 12px;
          position: absolute;
          top: 28px;
          left: 275px;
          z-index: 30;
          padding: 0 12px;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 1s infinite linear;
        }

        .gas-y2 {
          position: absolute;
          left: 261px;
          top: 38px;
          height: 270px;
          width: 12px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 1s infinite linear;
        }

        .gas-y3 {
          position: absolute;
          right: 267px;
          top: 40px;
          height: 270px;
          width: 12px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToTop 1s infinite linear;
        }

        .gas-y4 {
          position: absolute;
          right: 268px;
          top: 316px;
          height: 12px;
          width: 300px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 1s infinite linear;
        }

        .gas-y5 {
          position: absolute;
          left: 310px;
          top: 316px;
          height: 12px;
          width: 220px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 1s infinite linear;
        }

        .gas-o {
          position: absolute;
          left: 142px;
          bottom: 231px;
          height: 12px;
          width: 340px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 1s infinite linear;

          &.slow {
            animation: gasToLeft 3s infinite linear;
          }
        }

        .gas-p1 {
          position: absolute;
          right: 109px;
          bottom: 257px;
          height: 126px;
          width: 12px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 1s infinite linear;

          &.slow {
            animation: gasToBottom 3s infinite linear;
          }
        }

        .gas-p2 {
          position: absolute;
          right: 142px;
          bottom: 231px;
          height: 12px;
          width: 322px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToRight 1s infinite linear;

          &.slow {
            animation: gasToRight 3s infinite linear;
          }
        }

        .gas-b1 {
          position: absolute;
          right: 578px;
          bottom: 25px;
          height: 141px;
          width: 12px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToBottom 1s infinite linear;

          &.slow {
            animation: gasToBottom 3s infinite linear;
          }
        }

        .gas-b2 {
          position: absolute;
          right: 280px;
          bottom: 24px;
          height: 12px;
          width: 298px;
          z-index: 30;
          background-size: inherit;
          background-position: 0 0;
          animation: gasToLeft 1s infinite linear;

          &.slow {
            animation: gasToLeft 3s infinite linear;
          }
        }
      }

      .info-btn {
        position: absolute;
        right: 570px;
        bottom: 66px;
        width: 60px;
        height: 22px;
        z-index: 30;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  /*报警提示框*/
  .tip-container {
    position: fixed;
    right: 20px;
    top: 20px;
    z-index: 110;
    width: 300px;
    height: auto;

    .tip-box {
      width: 300px;
      height: 134px;
      margin-bottom: 8px;
      position: relative;
      background-size: cover;
      animation: bounceInLeft 1s linear;

      .top-close {
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        z-index: 120;
      }

      .tip-color-1 {
        color: #FF386B;
      }

      .tip-color-2 {
        color: #F5E74F;
      }

      .tip-color-3 {
        color: #1FFFFF;
      }

      .img-box {
        padding-top: 24px;
        padding-bottom: 11px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
          width: 32px;
          height: 30px;
        }

        & > span {
          padding-left: 12px;
          font-weight: bold;
          font-size: 20px;
        }
      }

      .msg {
        text-align: center;
        color: #ffffff;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        padding: 0 30px;
        height: 44px;
        overflow: hidden;
      }
    }
  }

  /*燃料弹框*/
  .battery-dialog {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 110;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .battery-modal {
      width: 1740px;
      height: 728px;
      background: transparent;
      position: relative;
      text-align: center;
      color: #FFFFFF;

      .close {
        position: absolute;
        right: 50px;
        top: 0;
        width: 32px;
        height: 32px;
        z-index: 99999;
        background: transparent;
        cursor: pointer;
      }

      .b-fan { /*风扇*/
        position: absolute;
        top: 154px;
        right: 720px;
        width: 36px;
        height: 36px;

        &.round {
          animation: round .5s infinite linear;
        }
      }

      .b-pump { /*水泵*/
        position: absolute;
        bottom: 178px;
        right: 244px;
        width: 40px;
        height: 40px;

        &.round {
          animation: round .6s infinite linear;
        }
      }

      .b-fire { /*火焰*/
        position: absolute;
        top: 313px;
        left: 667px;
        width: 40px;
        height: 40px;

        &.running {
          animation: swing 0.3s infinite ease-in-out;
        }
      }

      .b-light { /*闪电*/
        position: absolute;
        top: 313px;
        left: 499px;
        width: 40px;
        height: 40px;

        &.running {
          animation: flash 1s infinite ease-in-out;
        }
      }

      .fan-top {
        position: absolute;
        top: 73px;
        right: 668px;
        width: 140px;
        height: 48px;
        line-height: 48px;
        font-weight: 500;
        font-size: 20px;
      }

      .fan-bottom {
        position: absolute;
        top: 224px;
        right: 724px;
        width: 28px;
        height: 22px;
        line-height: 22px;
        font-weight: 400;
        font-size: 14px;
      }

      .words-item {
        position: absolute;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }

      .left1 {
        left: 120px;
        top: 260px;
        width: 88px;
      }

      .left2 {
        left: 236px;
        top: 260px;
        width: 88px;
      }

      .left3 {
        left: 120px;
        top: 494px;
        width: 88px;
      }

      .left4 {
        left: 236px;
        top: 494px;
        width: 88px;
      }

      .left5 {
        left: 359px;
        top: 389px;
        width: 88px;
      }

      .box-item {
        position: absolute;
        text-align: center;
        min-width: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .box-item .name {
        font-weight: 400;
        font-size: 14px;
        color: #F5E74F;
        line-height: 20px;
        white-space: nowrap;
      }

      .box-item .value {
        min-width: 64px;
        height: 24px;
        background: rgba(31, 255, 255, 0.1);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid rgba(31, 255, 255, 0.3);
        font-weight: 500;
        font-size: 14px;
        color: #1FF0FF;
        line-height: 24px;
        text-align: center;
        padding: 0 3px;

        &.warning {
          border: 1px solid rgba(255, 56, 107, 0.5);
          background: rgba(255, 56, 107, 0.1);
          color: #FF386B;
        }
      }

      .right-fan {
        top: 146px;
        left: 1047px;
      }

      .right-t19 {
        left: 517px;
        top: 192px;
      }

      .right-t21 {
        left: 560px;
        top: 301px;
      }

      .right-t22 {
        left: 560px;
        top: 374px;
      }

      .right-t20 {
        left: 523px;
        top: 439px;
      }

      .right-t4 {
        left: 655px;
        top: 261px;
      }

      .right-oxy {
        left: 733px;
        top: 293px;
      }

      .right-t3 {
        left: 696px;
        top: 415px;
      }

      .right-t15 {
        left: 863px;
        top: 415px;
      }

      .right-t9 {
        left: 959px;
        top: 306px;
      }

      .right-t7 {
        top: 282px;
        right: 133px;
      }

      .right-t13 {
        top: 261px;
        right: 280px;
      }

      .right-t12 {
        top: 415px;
        right: 287px;
      }

      .right-t10 {
        top: 261px;
        right: 395px;
      }

      .right-t11 {
        top: 415px;
        right: 395px;
      }

      .right-t23 {
        top: 415px;
        right: 600px;
      }

      .right-pump {
        top: 489px;
        right: 178px;

        .name {
          margin-top: 3px;
          color: #fff
        }
      }

      .right-bump-speed {
        top: 555px;
        right: 265px;

        .name {
          margin-bottom: 3px;
          color: #fff
        }
      }

      .left-DC-1 {
        left: 246px;
        top: 285px;
      }

      .left-DC-2 {
        left: 246px;
        top: 518px;
      }

      .left-P {
        left: 372px;
        top: 415px;
      }

      .right-name {
        position: absolute;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        width: 86px;
        height: 22px;
        text-align: center;

        &.name1 {
          left: 475px;
          top: 385px;
        }

        &.name2 {
          left: 646px;
          top: 385px;
        }

        &.name3 {
          left: 740px;
          top: 385px;
        }

        &.name4 {
          left: 853px;
          top: 385px;
        }

        &.name5 {
          right: 605px;
          top: 385px;
        }

        &.name6 {
          right: 388px;
          top: 385px;
        }

        &.name7 {
          right: 280px;
          top: 385px;
        }

        &.name8 {
          width: 120px;
          right: 320px;
          top: 482px;
        }

        &.name9 {
          width: 120px;
          right: 718px;
          bottom: 124px;
        }

        &.name10 {
          width: 42px;
          right: 520px;
          bottom: 244px;
        }

        &.name11 {
          width: 100px;
          height: 48px;
          line-height: 48px;
          right: 112px;
          top: 334px;
          font-weight: 500;
          font-size: 20px;
        }

        &.name12 {
          right: 132px;
          bottom: 78px;
        }
      }

      .b-title {
        position: absolute;
        bottom: 70px;
        font-weight: 500;
        font-size: 24px;
        color: #F5E74F;
        line-height: 32px;

        &.t1 {
          left: 209px;
        }

        &.t2 {
          left: 955px;
        }
      }

      /*电池箭头*/
      .battery-line {
        position: absolute;
        background-size: inherit;
        background-position: 0 0;

        &.line1 {
          top: 240px;
          left: 520px;
          height: 12px;
          width: 300px;
          animation: arrowToRight 2s infinite linear;
        }

        &.line2 {
          top: 497px;
          right: 716px;
          height: 12px;
          width: 500px;
          z-index: 100;
          animation: arrowToRight 2s infinite linear;
        }

        &.line3 {
          top: 346px;
          left: 555px;
          height: 12px;
          width: 95px;
          z-index: 100;
          animation: arrowToLeft 2s infinite linear;
        }

        &.line4 {
          top: 360px;
          left: 555px;
          height: 12px;
          width: 95px;
          animation: arrowToLeft 2s infinite linear;
        }

        &.line5 {
          top: 354px;
          left: 799px;
          height: 12px;
          width: 50px;
          animation: arrowToLeft 2s infinite linear;
        }

        &.line6 {
          top: 354px;
          left: 948px;
          height: 12px;
          width: 98px;
          animation: arrowToLeft 2s infinite linear;
        }

        &.line7 {
          top: 354px;
          right: 480px;
          height: 12px;
          width: 108px;
          animation: arrowToLeft 2s infinite linear;
        }

        &.line8 {
          bottom: 160px;
          right: 500px;
          height: 12px;
          width: 548px;
          animation: arrowToRight 2s infinite linear;
        }

        &.line9 {
          bottom: 220px;
          right: 247px;
          height: 65px;
          width: 12px;
          animation: arrowToTop 2s infinite linear;

        }

        &.line10 {
          bottom: 122px;
          right: 247px;
          height: 60px;
          width: 12px;
          animation: arrowToTop 2s infinite linear;
        }

        &.line11 {
          bottom: 170px;
          right: 490px;
          height: 110px;
          width: 12px;
          animation: arrowToBottom 2s infinite linear;
        }

        &.line12 {
          bottom: 230px;
          left: 511px;
          height: 93px;
          width: 12px;
          animation: arrowToTop 2s infinite linear;
        }

        &.line13 {
          top: 250px;
          left: 510px;
          height: 60px;
          width: 12px;
          animation: arrowToBottom 2s infinite linear;
        }

        &.line14 {
          top: 276px;
          left: 949px;
          height: 12px;
          width: 54px;
          animation: arrowToRight 2s infinite linear;
        }

        &.line15 {
          top: 410px;
          left: 683px;
          height: 150px;
          width: 12px;
          animation: arrowToTop 2s infinite linear;
        }
      }
    }
  }
}

.fade-enter, .fade-leave-to {
  display: none;
  opacity: 0;
}

.fade-enter-active {
  animation: dialogOpen .5s ease;
}

.fade-leave-active {
  animation: dialogClose .5s ease;
}

@keyframes dialogOpen {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes dialogClose {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  100% {
    transform: none;
  }
}

/* 轮胎滚动动画 */
@keyframes round {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes gasToRight {
  0% {
    background-position: 40px 0;
  }
}

@keyframes gasToLeft {
  0% {
    background-position: -40px 0;
  }
}

@keyframes gasToBottom {
  0% {
    background-position: 0 -40px;
  }
}

@keyframes gasToTop {
  0% {
    background-position: 0 40px;
  }
}

/*-------*/
@keyframes arrowToRight {
  0% {
    background-position: 92px 0;
  }
}

@keyframes arrowToLeft {
  0% {
    background-position: -92px 0;
  }
}

@keyframes arrowToBottom {
  0% {
    background-position: 0 -92px;
  }
}

@keyframes arrowToTop {
  0% {
    background-position: 0 92px;
  }
}

@keyframes flash {
  from, 50%, to {
    opacity: 0;
  }

  25%, 75% {
    opacity: 1;
  }
}

@keyframes swing {
  20% {
    -webkit-transform: rotate3d(0, 0, 1, 15deg);
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    -webkit-transform: rotate3d(0, 0, 1, -10deg);
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    -webkit-transform: rotate3d(0, 0, 1, 5deg);
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    -webkit-transform: rotate3d(0, 0, 1, -5deg);
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    -webkit-transform: rotate3d(0, 0, 1, 0deg);
    transform: rotate3d(0, 0, 1, 0deg);
  }
}

.params-container {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px;
  color: #ffffff;
  z-index: 60;
  background: rgba(0, 0, 0, .8);
  height: 85%;
  width: 460px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0;
  }

  .params-box {
    display: flex;
    column-gap: 10px;
    flex-wrap: wrap;

    p {
      font-size: 14px;
      line-height: 1.4;
      width: calc((100% - 20px) / 2);
      margin-bottom: 5px;
    }

    hr {
      width: 100%;
      margin-block-start: 0.5em;
      margin-block-end: 0.5em;
    }

    h4 {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}
</style>
